import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';

import { ClientQLCollectionItem } from '@skylab-shared/business';
import { EnumTranslatorBase, TinKind } from '@skylab-shared/dataModel';

import { FavouriteSwitchCommand } from '@skylab-angular-shared/business';
import { CommandBus, EnumTranslator } from '@skylab-angular-shared/core';
import { IComponentWrapper, StarComponent } from '@skylab-angular-shared/ui';
import { DeepWriteable } from '@skylab-shared/types';

@Component({
    selector: 'skl-client-quick-list-item',
    templateUrl: './quick-list-client-item.component.html',
    imports: [StarComponent]
})
export class ClientQuickListItemComponent implements IComponentWrapper {
    @Input() public data!: ClientQLCollectionItem;
    @Output() public onSwitch = new EventEmitter<void>();

    public constructor(
        @Inject(EnumTranslator) private readonly enumTranslator: EnumTranslatorBase,
        @Inject(CommandBus) private readonly commandBus: CommandBus
    ) { }

    public translateClientTinKind(tinKind: TinKind): string {
        return this.enumTranslator.getLabeledEnumValue(TinKind, tinKind).label;
    }

    public async switchFavouriteClientAsync(item: DeepWriteable<ClientQLCollectionItem>): Promise<void> {
        const result = await this.commandBus.commandAsync(new FavouriteSwitchCommand({id: item.externalId, value: !item.favourite, type: 'client'}));
        if (result) {
            item.version = result.version;
            item.favourite = !item.favourite;
            this.onSwitch.emit();
        }
    }
}
